const calculatePercentage = (partialValue: number, totalValue: number) => {
  if (totalValue === 0) return 0;

  return (100 * partialValue) / totalValue;
};

export { calculatePercentage };
